import React, { Component } from "react";
import { ExperimentPoster } from "@learningblocks/storybook-components";
import { ExperimentalSetupPosterIcon } from '@learningblocks/storybook-components/lib/Icons';
import { pHScalePosterIcon } from '@learningblocks/storybook-components/lib/Icons';

export class Graphics extends Component {

  render() {
    return (
      <ExperimentPoster
        id={this.props.id}
        type={this.props.type}
        image={
          (this.props.type === "Experimental setup poster")?
            ExperimentalSetupPosterIcon:
            pHScalePosterIcon
        }
        altText={
          (this.props.type === "Experimental setup poster")?
            '4 tubes filled with green (pH 7) BTB solution and sealed with stoppers. Tubes 2 and 4 are in boxes. Tubes 3 and 4 each contain a water plant.':
            'pH-scale poster - A poster showing the ideal pH range for BTB (pH 6.0 to pH 8.0). The poster shows the colors associated with each pH. These are: pH 2.0 to pH 6.3 (shades of yellow), pH 6.5 to pH 7.1 (shades of green), and pH 7.3 to pH 12 (shades of blue).'
        }
        style={{
          width: (this.props.type === "Experimental setup poster")?150:500,
          pointerEvents: "none"
        }}
      />
    );
  }
}
